import React from 'react';

const BusinessAccount = ({ paymentMethod }) => (
  <div>
    <div className="card-body text-weight-light">
      <div className="vertical-padding-bottom">
        <strong>{`${paymentMethod.accountName} Account`}</strong>
      </div>
      <div>
        All charges on this business account will be billed to the designated company. To make changes contact your company administrator.
      </div>
    </div>
    <div className="card-footer hidden-md" />
  </div>
);

export default BusinessAccount;
